import { GameVars } from "../../GameVars";
import { RoadManager } from "./Roadmanager";

export class DPad extends Phaser.Group {

    private base: Phaser.Image;
    private dpad: Phaser.Image;
    private moving: boolean;

    constructor(game: Phaser.Game) {

        super(game, null, "d-pad");

        this.scale.set(GameVars.scaleX * 1.25, 1.25);
        this.alpha = .5;

        this.moving = false;

        this.base = new Phaser.Image(this.game, 0, 0, "texture_atlas_1", "base_dpad.png");
        this.base.anchor.set(.5);
        this.add(this.base);

        this.dpad = new Phaser.Image(this.game, 0, 0, "texture_atlas_1", "dpad.png");
        this.dpad.inputEnabled = true;
        this.dpad.events.onInputDown.add(this.onDownDPad, this);
        this.dpad.events.onInputUp.add(this.onUpDPad, this);
        this.dpad.anchor.set(.5);
        this.add(this.dpad);
    }

    public update(): void {

        super.update();
        
        if (this.moving) {

            if (this.game.input.activePointer.x - this.x > 200 || this.game.input.activePointer.x - this.x < -200) {
                return;
            }

            this.dpad.x = this.game.input.activePointer.x - this.x;
            this.dpad.y = this.game.input.activePointer.y - this.y;

            if (this.dpad.x > 35) {
                this.dpad.x = 35;
            } else if (this.dpad.x < -35) {
                this.dpad.x = -35;
            }

            if (this.dpad.y > 35) {
                this.dpad.y = 35;
            } else if (this.dpad.y < -35) {
                this.dpad.y = -35;
            }
        } else {
            this.dpad.position.set(0);
        }

        let x = this.dpad.x / 35;
        let y = this.dpad.y / 35;

        RoadManager.moveChicken(x, y);
    }

    private onDownDPad(): void {
        this.moving = true;
    }

    private onUpDPad(): void {
        this.moving = false;
    }
}